import http from '@/http'

const getByOrderId = (orderId) => {
	// Keep only relation filter here; `order[...]` is reserved for sorting and collides with this param.
	const path = `logs?order=/api/orders/${orderId}&itemsPerPage=200&page=1`
	return http.get(path)
}

export default {
	getByOrderId
}
